<template>
  <div>
    <v-img 
    v-if="getType() === 'v-img'"
    :src="media.URL"
    class="elevation-2"
    :width="media.width"
    :height="media.height"
    ></v-img>

    <div class="position-relative text-center">
      <cld-image
        :cloudName="cldConfig.CLOUD_NAME" 
        :public-id="media.publicID"
        :width="media.width" 
        :loading="media.trans.loading || ''" 
        v-if="getType() === 'cld-image'"
        :class="media.overlay ? 'overlay-main-img' : ''"
      >
        <cld-transformation 
        :fetch-format="media.trans.fetchFormat || 'auto'"
        :width="media.trans.width || 720"
        :crop="media.trans.crop || 'scale'" />
      </cld-image>
      <div class="overlay-img-area" v-if="media.overlay">
        <img :src="getOverlayType()" v-if="getType() === 'cld-image'"  />
      </div>
    </div>

    <div :class="(media.className) || ''" v-if="getType() === 'cld-video'">
      <div>
        <video
        :id="`cld-player-${media.videoID}`" 
        :data-cld-public-id="media.publicID"
        controls  
        :class="`cld-video-player ${media.postView ? 'post-view' : ''} cld-fluid`">
        </video>
      </div>
      <btn-download :url="checkURL(media.URL)" label="Download" v-if="media.download"></btn-download>
      <div :class="`overlay-img-area ${media.creatorView ? 'creator-view': ''}`" v-if="media.overlay" @click="videoAction()">
        <img :src="getOverlayType()" />
      </div>
    </div>

    <div>
      <v-img v-if="getType() === 'native-image'"
        :src="previewMedia"           
        class="custom-preview-img grey lighten-2"      
      >
      </v-img>
      <div class="overlay-img-area" v-if="media.overlay">
        <img :src="getOverlayType()" v-if="getType() === 'native-image'"  />
      </div>
    </div>
    <div :class="(media.className) || ''" v-show="getType() === 'native-video'">
      <div :class="(media.vdoClassName) || ''">
        <video class="custom-preview-video" :id='mediaFileName' controls>             
            Your browser does not support the video tag.
        </video>
      </div>
      <btn-download :url="checkURL(media.URL)" label="Download" v-if="media.download"></btn-download>
      <div :class="`overlay-img-area ${media.creatorView ? 'creator-view': ''}`" v-if="media.overlay" @click="videoAction()">
        <img :src="getOverlayType()" />
      </div>
    </div>
    <div :class="(media.className) || ''" v-show="getType() === 's3-video'">
      <div :class="(media.vdoClassName) || ''">
        <video class="custom-preview-video" :id='mediaFileName' :src="media.URL" controls>             
            Your browser does not support the video tag.
        </video>
      </div>
      <btn-download :url="checkURL(media.URL)" label="Download" v-if="media.download"></btn-download>
      <div :class="`overlay-img-area ${media.creatorView ? 'creator-view': ''}`" v-if="media.overlay" @click="videoAction()">
        <img :src="getOverlayType()" />
      </div>
    </div>
    <div v-if="getType() === 's3-image'">
      <v-img
        :src="media.URL"           
        class="custom-preview-img grey lighten-2"      
      >
      </v-img>
      <div class="overlay-img-area" v-if="media.overlay">
        <img :src="getOverlayType()"  />
      </div>
    </div>

    <iframe 
    :class="media.className || ''" 
    :width="media.width"
    :height="media.height"
    :src="media.URL" 
    v-if="getType() === 'iframe'" 
    allow="autoplay" 
    scrolling="no" 
    seamless="" 
    allowFullScreen></iframe>

    <gDrive-post-view :url="media.URL" v-else-if="getType() === 'driveCustomView'" :darkTheme="true" />
  </div>
</template>
<script>
  // v2 - changed multiple props to one media prop
  import config from '@/config';
  // import utils from '@/utils';
  import GDrivePostView from '../gdrive/GDrivePostView';
  import BtnDownload from './BtnDownload';
  export default {
    name: 'CustomMediaV2',
    components: { GDrivePostView, BtnDownload },
    props: ['media'],
    data() {
      return {
        cldConfig: config.cldConfig,
        cld: null,
        vplayer: null,
        playCalled: null,
        previewMedia: null
      }
    },
    watch: {
      media: {
        handler: function (newValue, oldVal) {
          if (newValue.file) {
            if (newValue.file.type.indexOf('image') !== -1) {
              this.previewMedia = newValue.preview.src
            } else {
              this.vplayer = document.getElementById(this.mediaFileName)
              let file = newValue.file;
              let blobURL = URL.createObjectURL(file);
              if (blobURL) {
                this.vplayer.src = blobURL
                document.getElementById(this.mediaFileName).src = blobURL
              }
              if (newValue.file.type.indexOf('mp4') !== -1) {
                this.vplayer.type = 'video/mp4'
              } else if (newValue.file.type.indexOf('quicktime') !== -1) {
                this.vplayer.type = 'video/quicktime'
              }
              this.vplayer.load()
              this.playCalled = true
            }
          }
        },
        deep: true
      }
    },
    mounted() {
      this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
      if (this.media.type === 'cld-video') {
        setTimeout(() => {
          this.renderCldVideo()
        }, 100)
      } else {
        if (this.media.file) {
          if (this.media.file.type.indexOf('image') !== -1) {
            this.previewMedia = this.media.preview.src
          } else {
            this.vplayer = document.getElementById(this.mediaFileName)
            let file = this.media.file;
            let blobURL = URL.createObjectURL(file);
            if (blobURL) {
              this.vplayer.src = blobURL
              document.getElementById(this.mediaFileName).src = blobURL
            }
            if (this.media.file.type.indexOf('mp4') !== -1) {
              this.vplayer.type = 'video/mp4'
            } else if (this.media.file.type.indexOf('quicktime') !== -1) {
              this.vplayer.type = 'video/quicktime'
            }
            this.vplayer.load()
            this.playCalled = true
          }
        }
      }
    },
    computed: {
      mediaFileName: function() {
        if (this.media.fileName) {
          return `postVdoMedia${this.media.fileName}`
        }
        return 'postVdoMedia'
      }
    },
    methods: {
      getType: function() {
        if (this.media.URL) {
          if (this.media.URL.includes('drive.google.com')) {
            if (this.media.type === 'driveCustomView') {
              return 'driveCustomView'
            }
            return 'iframe'
          }
          if (this.media.URL.includes('s3-ap-southeast-1')) {
            if (this.media.isVideo) {
              setTimeout(() => {
                if (!this.vplayer) {
                  this.vplayer = document.getElementById(this.mediaFileName)
                }
              }, 1000)
              return 's3-video'
            }
            if (this.media.isImage) {
              return 's3-image'
            }
          }
        }
        if (this.media.file) {
          if (this.media.file.type.indexOf('image') !== -1) {
            return 'native-image'
          } else if (this.media.file.type.indexOf('video') !== -1) {
            return 'native-video'
          }
        }
        return this.media.type
      },
      getOverlayType() {
        if (this.media.overlayType) {
          if (this.media.overlayType === 'TikTok') {
            return '/static/img/post/tiktok.png'
          } else if (this.media.overlayType === 'IGStory') {
            return '/static/img/post/ig-story.png'
          } else if (this.media.overlayType === 'IG') {
            return '/static/img/post/ig-cutoff-post.png'
          }
        }
        return ''
      },
      async renderCldVideo() {
        let options = {}
        if (this.media.preview) {
          options.controls = false
        }
        // // const posterURL = `https://res.cloudinary.com/${this.cldConfig.CLOUD_NAME}/video/upload/c_scale,w_760,q_auto/v1/${this.media.publicID}.jpg`
        // const posterURL = `https://res.cloudinary.com/${this.cldConfig.CLOUD_NAME}/video/upload/v1/${this.media.publicID}.jpg`
        // let isTransExist = await utils.func.checkURLExist(posterURL)
        // if (isTransExist) {
        //   // options.source = this.checkURL(this.media.URL.replace('video/upload/', 'video/upload/c_scale,w_760,q_auto/'))
        //   options.source = this.checkURL(this.media.URL)
        //   options.posterOptions = { publicId: `${posterURL}.jpg` }
        // }
        this.vplayer = this.cld.videoPlayer(`cld-player-${this.media.videoID}`, options);
        this.vplayer.on('playing', (event) => {
          this.playCalled = true
        })
      },
      checkURL(url) {
        if (url.includes('res.cloudinary.com')) {
          return url.replace('http:', 'https:')
        }
        return url
      },
      videoAction() {
        if (this.playCalled) {
          this.playCalled = null
          this.vplayer.pause()
        } else {
          this.vplayer.play()
          this.playCalled = true
        }
        // var vid = document.getElementById(this.mediaFileName);
        // console.log(vid)
        // vid.onplaying = function() {
        //   console.log('The video is now playing');
        // };
      }
    }
  }
</script>
<style lang="css" scoped>
.report-video {
  width: 320px;
}
.post-video {
  max-width: 270px;
  margin: 0 auto;
}
.media-iframe {
  box-sizing: content-box;
  width: 350px;
  border-radius: 2%;
  border: 1px solid #fff;
}
.cld-video-player.post-view {
  width: 265px;
  height: 470px!important;
  padding-top: 0!important;
}
.overlay-main-img {
  max-height:470px!important;
  height: 470px!important;
  object-fit:cover;
  min-width: 265px;
  max-width:265px;
}
.overlay-img-area {
  position:absolute;
  top:0;
  z-index:100;
  width:100%;
}
.overlay-img-area.creator-view {
  top:12px;
  width:auto;
}
.overlay-img-area img {
  height:470px;
}
.custom-preview-img {
  min-height: 440px;
  max-height: 458px;
  max-width: 265px;
  object-fit: cover;
}
.custom-preview-video {
  min-height: 440px;
  max-height: 458px;
  max-width: 265px;
}
.position-relative {
  position: relative;
}
@media (max-width: 767px) {
  .media-iframe {
    width: 290px;
  }
}
</style>



// WEBPACK FOOTER //
// CustomMediaV2.vue?82d4f298